import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation, i18n } from 'server/i18n'

import style from './ContactInfoAlt.style'

const ContactInfoAltStyled = styled.div(props => ({ ...style(props) }))

const ContactInfoAlt = ({ t }) => {
    return (
        <ContactInfoAltStyled>
            <div className="infoList-wrapper">
                <div className="infoText">
                    {i18n.language === 'en' ? (
                        <>
                            <h3 className="title">Where to find us</h3>
                            <p>
                                Merk & Merk&apos;s service station and headquarters are located in the beautiful marina
                                of <strong>Tribunj</strong>, a lovely little town in the heart of the Croatian coast.
                            </p>
                            <p>
                                Since July 2024, we have also opened an office at{' '}
                                <strong>Lake Constance in Germany</strong> to offer our customers the best possible
                                service there too. And that&apos;s not all, since April 2025 you can also find us in
                                Palma on <strong>Mallorca</strong> - one of the most important yachting hotspots in the
                                Mediterranean. Wherever you want to realize your dream of yachting - we are at your side
                                with our experience and passion.
                            </p>
                            <p>
                                Discover the best yacht offers for sale with us - in Croatia and throughout Europe.
                                Whether beginner or experienced yacht owner, used boat or new boat, sailing yacht or
                                motor yacht - everyone is faced with the same question: Which yacht really suits me?
                                And: What should I look for when buying?
                                <br />
                                Merk & Merk can help you with over 15 years of experience in the international brokerage
                                business - competently, independently and personally.
                                <br />
                                As an official dealer for Princess Yachts in Germany and on the Adriatic, we offer you
                                access to excellent new builds and certified pre-owned boats.
                            </p>
                        </>
                    ) : (
                        ''
                    )}

                    {i18n.language === 'de' ? (
                        <>
                            <h3 className="title">Wo Sie uns finden</h3>
                            <p>
                                Die Service-Station und das Headquarter von Merk & Merk befinden sich in der malerischen
                                Marina <strong>Tribunj</strong>, einer wunderschönen kleinen Stadt im Herzen der
                                kroatischen Küste.
                            </p>
                            <p>
                                Seit Juli 2024 sind wir zusätzlich mit einem Büro am{' '}
                                <strong>Bodensee in Deutschland</strong> vertreten, um auch dort unseren Kunden
                                bestmöglichen Service zu bieten. Und das ist noch nicht alles, denn seit April 2025
                                finden Sie uns auch in Palma auf <strong>Mallorca</strong> – einem der wichtigsten
                                Yachting-Hotspots im Mittelmeer. Wo auch immer Sie Ihren Traum vom Yachting
                                verwirklichen möchten – wir stehen Ihnen mit unserer Erfahrung und Leidenschaft zur
                                Seite.
                            </p>
                            <p>
                                Entdecken Sie mit uns die besten Yachtangebote zum Kauf – in Kroatien und ganz Europa.
                                Ob Einsteiger oder erfahrener Yachteigner, ob Gebrauchtboot oder Neuboot, Segelyacht
                                oder Motoryacht – alle stehen vor der gleichen Frage: Welche Yacht passt wirklich zu
                                mir? Und: Worauf muss ich beim Kauf achten?
                                <br />
                                Merk & Merk begleitet Sie dabei mit über 15 Jahren Erfahrung im internationalen
                                Bootshandel – kompetent, unabhängig und persönlich.
                                <br />
                                Als offizieller Händler für Princess Yachts in Deutschland und an der Adria bieten wir
                                Ihnen Zugang zu erstklassigen Neubauten sowie geprüften Gebrauchtbooten.
                            </p>
                        </>
                    ) : (
                        ''
                    )}
                </div>
                <ul className="infoList">
                    <li>
                        <span className="info-title">KROATIEN</span>
                        <span className="info-value">
                            <span>Marina Tribunj</span>
                            <br />
                            <span>Merk & Merk Jahte Servis Tribunj d.o.o</span>
                            <br />
                            <span>Jurjevgradska ul. 2</span>
                            <br />
                            <span>22212 Tribunj</span>
                        </span>
                    </li>

                    <li>
                        <span className="info-title">DEUTSCHLAND / BODENSEE</span>
                        <span className="info-value">
                            <span>BMK Yachthafen</span>
                            <br />
                            <span>Merk & Merk GmbH</span>
                            <br />
                            <span>Argenweg 60/5</span>
                            <br />
                            <span>88085 Langenargen</span>
                        </span>
                    </li>

                    <li>
                        <span className="info-title">SPANIEN / MALLORCA</span>
                        <span className="info-value">
                            <span>Motorworld Mallorca</span>
                            <br />
                            <span>Merk & Merk SL</span>
                            <br />
                            <span>Camí Vell de Llucmajor 112</span>
                            <br />
                            <span>Platja de Palma, 07007 Palma</span>
                        </span>
                    </li>
                </ul>
            </div>
        </ContactInfoAltStyled>
    )
}

ContactInfoAlt.propTypes = {
    t: PropTypes.func.isRequired
}

export default withTranslation('common')(withTheme(ContactInfoAlt))
